<template>
    <div>
        <MainHeader />

        <b-container id="image-container" :style="domiciliationBackground" fluid class="p-3 p-md-4 p-lg-5 text-white bg-cover text-shadow">
            <h1 class="mb-5 text-shadow">{{ title }}</h1>
            <p class="h2">{{ text }}</p>
        </b-container>

        <b-container fluid class="p-3 p-md-4 p-lg-5">
            <p>
                Gérer soi-même toute sa paperasse administrative, c'est ennuyeux et chronophage, n'est-ce pas ?
                <br /> <br />
                Vous avez certainement mieux à faire pour <strong>développer votre business</strong> et surtout l'envie de <strong>vous consacrer pleinement à votre coeur de métier</strong>.
                <br /> <br />
                En domiciliant votre entreprise, vous confiez toute cette partie de votre activité à une <strong>équipe de professionnels de l'administratif</strong>. Plus de soucis !
                <br /> <br />
                Plus de contraintes, mais également des <strong>bonus à la clé</strong> :
            </p>

            <ul class="pl-4">
                <li>Une <strong>solution économique d'implantation</strong></li>
                <li>Des <strong>services complémentaires et personnalisés</strong></li>
                <li>Une <strong>adresse de prestige</strong> pour <strong>renforcer votre image de marque</strong></li>
            </ul>

            <p>
                Globalement, une <strong>solution d'accélération de votre croissance</strong> !
                <br /> <br />
                Alors ne perdez plus votre temps à réaliser des tâches que vous pouvez facilement déléguer à moindres frais : <strong>domiciliez votre entreprise</strong> dès à présent.
            </p>
        </b-container>

        <b-container fluid class="p-3 p-md-4 p-lg-5 bg-light">
            <h3 class="mb-5">Nos adresses</h3>

            <b-card-group deck>
                <b-card v-for="(address, index) in services.domiciliation.addresses" :key="index"
                :title="address.text"
                :img-src="address.img.src"
                :img-alt="address.img.alt"
                img-top
                >
                    <b-card-text class="d-flex justify-content-start align-items-center">
                        <img src="../../assets/images/icons/location.svg" alt="Icone de localisation" class="mr-2" width="20" height="20" />
                        <p class="mt-3 text-black-50">{{ address.value }}</p>
                    </b-card-text>

                    <b-row align-v="baseline">
                        <b-col>
                            <b-button :to="{ name: 'address', params: { addressId: index + 1 }}" size="lg">Voir</b-button>
                        </b-col>

                        <b-col cols="auto">
                            <p v-if="address.recurrence != null" class="h5">{{ address.price }}{{ services.currency}} {{ services.tva }} / {{ address.recurrence }}</p>

                            <p v-else class="h5">{{ address.price }}{{ services.currency}} {{ services.tva }}</p>
                        </b-col>
                    </b-row>
                </b-card>
            </b-card-group>
        </b-container>

        <Sidebar />

        <MainFooter />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import MainHeader from '../../components/MainHeader.vue'
    import Sidebar from '../../components/Sidebar.vue'
    import MainFooter from '../../components/MainFooter.vue'

    export default {
        components: {
            MainHeader,
            Sidebar,
            MainFooter
        },
        data() {
            return {
                title: 'Domiciliez votre entreprise à Paris, en moins de 5 minutes, dès 39€',
                text: 'Retrouvez nos adresses de domiciliation à Paris pour domicilier le siège social de votre entreprise'
            }
        },
        computed: {
            domiciliationBackground() {
                return 'background-image: url('+this.services.domiciliation.img+')'
            },
            ...mapState(['services'])
        }
    }
</script>
